import React from "react";
import VideoIcon from "../../../Icons/VideoIcon";
import { Hotspot, TourData } from "../../../../Types";
import { useViewerPopupStore } from "../../../../state management/zustand/viewer-stores";

function VideoPopup(props: {
  tourData: TourData;
  popup: Hotspot;
  zoom: number;
}) {
  const { setOpen } = useViewerPopupStore();

  return (
    <div
      tooltip-text={
        props.tourData.popups.find((one) => one.id === props.popup.target)
          ?.title
      }
      className="viewer-exp-icon"
    >
      <VideoIcon
        width="3.75em"
        height="3.75em"
        fill="#fff"
        stroke="#000"
        strokeWidth="20px"
        onClick={() => {
          setOpen(props.popup.target!);
        }}
        style={{ opacity: ((props.zoom - 15) * 100) / 76 <= 30 ? 0.3 : 1 }}
      />
    </div>
  );
}

export default VideoPopup;
